import React from "react";
import Footer from "../Components/Footer/Footer";
import FormRecover from "../Components/ForgotPass/FormRecover/FormRecover.jsx";
import NavBar from "../Components/NavBar/NavBar";
function RecoverPass() {
  return (
    <div>
      <NavBar />
      <FormRecover />
      <Footer />
    </div>
  );
}

export default RecoverPass;
